import LeaveBalanceList from "@/controllers/leave_balance/leave-balance-list.js";

export default {
  extends: LeaveBalanceList,
}
